export const UI_LANGUAGES = ['sv', 'en', 'lt', 'de'] as const;

export type UiLanguage = (typeof UI_LANGUAGES)[number];

const DATE_LOCALES: Record<UiLanguage, string> = {
  sv: 'sv-SE',
  en: 'en-GB',
  lt: 'lt-LT',
  de: 'de-DE',
};

export function uiLanguage(value: string | null | undefined): UiLanguage {
  const base = (value ?? '').toLowerCase().split('-')[0];
  if ((UI_LANGUAGES as readonly string[]).includes(base)) return base as UiLanguage;
  return 'sv';
}

export function uiDateLocale(value: string | null | undefined): string {
  return DATE_LOCALES[uiLanguage(value)];
}
